import { highlights } from "@/mocks/content";

export default function Highlights() {
  return (
    <section id="highlights" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-3xl">
          <span className="text-xs md:text-sm font-label font-medium tracking-widest text-accent-700 uppercase">
            Why this page
          </span>
          <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
            整理这套目录，能帮你省下什么
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700 font-body">
            找资源最耗时间的往往不是「看」，而是「找」和「判断」。下面这些做法，
            都是为了让你更快进入学习状态。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {highlights.map((item, index) => (
            <article
              key={item.id}
              className={`rounded-lg border p-5 md:p-6 ${
                index === 0
                  ? "bg-accent-500 border-accent-500 text-background-50 dark:text-foreground-950"
                  : "bg-background-50 border-background-200/70"
              }`}
            >
              <span
                className={`w-11 h-11 flex items-center justify-center rounded-md text-xl ${
                  index === 0
                    ? "bg-background-50/20 text-background-50 dark:text-foreground-950"
                    : "bg-primary-100 text-primary-700"
                }`}
              >
                <i className={item.icon}></i>
              </span>
              <h3
                className={`mt-4 font-heading font-semibold text-base md:text-lg ${
                  index === 0
                    ? "text-background-50 dark:text-foreground-950"
                    : "text-foreground-950"
                }`}
              >
                {item.title}
              </h3>
              <p
                className={`mt-2 text-xs md:text-sm leading-relaxed font-body ${
                  index === 0
                    ? "text-background-50/90 dark:text-foreground-900"
                    : "text-foreground-600"
                }`}
              >
                {item.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}